import React from 'react'
import { ContentHeader } from 'components/basic'
import { UserCreator } from 'projects/flow-gui-access/components/2.4'
import FlowView from 'components/core/FlowView'

class UserCreate extends FlowView {
  constructor (props) {
    super(props, 'Create User')
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='User' icon='fa-user' subtitle='Create new user' buttons={[ { icon: 'fa-arrow-left', event: () => (window.location.hash = '/users') } ]} />
        <hr />
        <div className='row'>
          <UserCreator />
        </div>
      </div>
    )
  }
}
export default UserCreate



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/users/create.js